import Marionette from "backbone.marionette";
import Radio from "backbone.radio";

const channel = Radio.channel("report");

class DataTableEvents extends Marionette.Object {
  initialize() {
    // start
    $(document).ajaxStart(this.start.bind(this));
    // stop
    $(document).ajaxStop(this.stop.bind(this));
    $(document).ajaxError(this.stop.bind(this));
  }

  start() {
    // do nothing
  }

  stop() {
    channel.trigger("dt-ajax-stop");
  }
}

export { DataTableEvents as default };
